import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    container: 'p-4 pt-6 space-y-4 md:(p-8 max-w-3/5) lg:max-w-2/5'
  }
} satisfies CMSConfig['blockBelow']
